export const FETCH_DASHBOARD_STARTED = 'FETCH_DASHBOARD_STARTED';
export const FETCH_DASHBOARD_COMPLETED = 'FETCH_DASHBOARD_COMPLETED';
export const FETCH_DASHBOARD_ERROR = 'FETCH_DASHBOARD_ERROR';

export const UPDATE_DASHBOARD_STARTED = 'UPDATE_DASHBOARD_STARTED';
export const UPDATE_DASHBOARD_COMPLETED = 'UPDATE_DASHBOARD_COMPLETED';
export const UPDATE_DASHBOARD_ERROR = 'UPDATE_DASHBOARD_ERROR';

export const ADD_DASHBOARD_COUNT_STARTED = 'ADD_DASHBOARD_COUNT_STARTED';
export const ADD_DASHBOARD_COUNT_COMPLETED = 'ADD_DASHBOARD_COUNT_COMPLETED';
export const ADD_DASHBOARD_COUNT_ERROR = 'ADD_DASHBOARD_COUNT_ERROR';

export const REMOVE_DASHBOARD_COUNT_STARTED = 'REMOVE_DASHBOARD_COUNT_STARTED';
export const REMOVE_DASHBOARD_COUNT_COMPLETED = 'REMOVE_DASHBOARD_COUNT_COMPLETED';
export const REMOVE_DASHBOARD_COUNT_ERROR = 'REMOVE_DASHBOARD_COUNT_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/dashboardActionTypes.js